<template>
	<div>
		<b-container class="bv-example-row password-area" style="background-color: #fff;height: 100vh;">
			<div class="mini-title">注册</div>
			<b-form class="password-form" style="margin-bottom: 20px;" @submit="onSubmit">
				<div class="label-name">
					<b-form-group label="身份证姓名:" id="input-group-7" label-for="input-7" label-cols-sm="2"
						label-align-sm="right">
						<b-form-input id="input-7" v-model="form.nickName" placeholder="请输入身份证姓名"
							required></b-form-input>
					</b-form-group>
				</div>
				<div class="label-name">
					<b-form-group label="身份证号:" id="input-group-7" label-for="input-7" label-cols-sm="2"
						label-align-sm="right">
						<b-form-input id="input-7" v-model="form.username" placeholder="请输入身份证号"
							required></b-form-input>
					</b-form-group>
				</div>
				<div class="label-name">
					<b-form-group label="确认身份证号:" id="input-group-7" label-for="input-7" label-cols-sm="2"
						label-align-sm="right">
						<b-form-input id="input-7" v-model="form.confirmName" placeholder="请输入确认身份证号"
							required></b-form-input>
					</b-form-group>
				</div>
				<div class="label-name">
					<b-form-group id="input-group-4" label="手机号码:" label-for="input-4" label-cols-sm="2"
						label-align-sm="right">
						<b-form-input id="input-4" type='tel' v-model="form.phonenumber" placeholder="请输入手机号码"
							required></b-form-input>
					</b-form-group>
				</div>
				<div class="label-name">
					<b-form-group description="验证码5分钟内有效" id="input-group-5" label="手机验证码:" label-for="input-5"
						label-cols-sm="2" label-align-sm="right">
						<b-form-input id="input-5" v-model="form.smsCode" type='tel' placeholder="请输入手机验证码"
							required></b-form-input>
						<el-button size="mini" type="success" @click.native.prevent="bindforgetSendCode"
							class="bind_code_gain" :disabled="disabled">{{ btnText }}</el-button>
					</b-form-group>
				</div>
				<div class="label-name">
					<b-form-group label="设置密码:" id="input-group-6" label-for="input-6" label-cols-sm="2"
						label-align-sm="right">
						<b-form-input id="input-6" type="password" v-model="form.password" placeholder="请输入密码"
							required></b-form-input>
					</b-form-group>
				</div>
				<div class="label-name">
					<b-form-group label="确认密码:" id="input-group-7" label-for="input-7" label-cols-sm="2"
						label-align-sm="right">
						<b-form-input id="input-7" type="password" v-model="form.confirmPassword" placeholder="请输入确认密码"
							required></b-form-input>
					</b-form-group>
				</div>
				<div style="text-align: center;">
					<button type="submit" class="main-btn">提&nbsp;&nbsp;交</button>
				</div>
			</b-form>
		</b-container>
	</div>
</template>

<script>
	import {
		getDicts,
		getCodeSms,
		register
	} from "@/api/login";
	import tencentCaptchaMixin from '@/mixins/tencentCaptcha'
	
	export default {
		mixins: [tencentCaptchaMixin],
		data() {
			return {
				form: {
					smsUuid: undefined,
					confirmPassword: undefined,
					password: undefined,
					phonenumber: undefined,
					nickName: undefined,
					username: undefined,
					confirmName: undefined,
					userType:'sys_user'
				},
				btnText: "获取验证码",
				disabled: false
			}
		},
		methods: {
			// 发送验证码
			bindforgetSendCode() {
				event.preventDefault()
				// 使用 mixin 提供的方法发送短信验证码
				this.sendSmsCodeWithCaptcha(this.form.phonenumber, (uuid) => {
					// 保存 uuid
					this.form.smsUuid = uuid;
					this.disabled = true;
					this.btnText = "请稍候...";
					setTimeout(() => {
						this.doLoop(60);
					}, 500);
				});
			},
			// 手机验证码的倒计时
			doLoop: function(seconds) {
				seconds = seconds ? seconds : 60;
				this.btnText = seconds + "s后获取";
				// this.code = code
				let countdown = setInterval(() => {
					if (seconds > 0) {
						this.btnText = seconds + "s后获取";
						--seconds;
					} else {
						this.btnText = "获取验证码";
						this.disabled = false;
						clearInterval(countdown);
					}
				}, 1000);
			},
			onSubmit(event) {
				event.preventDefault()
				var reg = /^1[0-9]{10}$/
				if (!reg.test(this.form.phonenumber)) {
					this.$message({
						showClose: true,
						type: 'error',
						message: '请输入正确的手机号！'
					})
				} else if (this.form.confirmName != this.form.username) {
					this.$message({
						showClose: true,
						type: 'error',
						message: '两次身份证号输入不一致！'
					})
				} else if (this.form.password != this.form.confirmPassword) {
					this.$message({
						showClose: true,
						type: 'error',
						message: '两次密码输入不一致！'
					})
				} else {
					register(this.form).then(res => {
						if (res.code == 200) {
							this.$message({
								showClose: true,
								type: 'success',
								message: '注册成功，请登录！'
							})
							this.$router.push({
								path: "/login"
							})
						} else {
							this.$message({
								showClose: true,
								type: 'error',
								message: res.msg
							})
						}
					})
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	.password-area {
		padding: 15px;

		.password-form {
			padding: 15px 200px;
		}
	}

	@media screen and (max-width: 997px) {
		.password-area {
			.password-form {
				padding: 0;
			}
		}
	}

	.label-name {
		position: relative;
	}

	.bind_code_gain {
		position: absolute;
		top: 5px;
		right: 10px;
	}

	.bannerPay {
		width: 100%;
		height: 230px;
		display: block;
		margin-top: 20px;
	}

	.mini-title {
		padding-left: 15px;
		position: relative;
		margin-bottom: 15px;
		font-weight: 600;
		text-align: center;
		font-size: 20px;
		color: #547af8;
	}
</style>